module.exports = __webpack_public_path__ + "img/1-8-2.05f1cd83.png";